import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useLegalTabs = () => {
  return useQuery({
    queryKey: ["legal-tabs"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("legal_tabs")
        .select("*")
        .order("updated_at", { ascending: false })
        .limit(1);

      if (error) {
        console.error("Error fetching legal tabs:", error);
        throw error;
      }

      return data;
    },
    staleTime: 0,
  });
};